import React from 'react';
import { useAuth } from '../services/AuthContext';
import { getParentOverview } from '../data/db';
import {
  Card,
  StatCard,
  Badge as LibBadge,
  ProgressBar,
  Icon
} from '../components/ComponentLibrary';
import { Heart, Activity, Award, Calendar } from 'lucide-react';
import './ParentDashboardNew.css';

export default function ParentDashboard() {
  const { user } = useAuth();
  const { child, progress } = getParentOverview();

  // Use the child's name from data, or a professional placeholder if it's the mock default
  const studentIdentity = child.name === 'أحمد' ? 'بطل كود ويف' : child.name;

  const completedCount = progress.filter(p => p.completed).length;
  const avgScore = completedCount > 0
    ? Math.round(progress.filter(p => p.completed).reduce((acc, p) => acc + p.score, 0) / completedCount)
    : 0;

  return (
    <div className="parent-dashboard-page">
      <header className="parent-header">
        <div className="header-content">
          <h1 className="parent-title">لوحة متابعة ولي الأمر: {user?.fullName || 'ولي الأمر'} <Icon name="parent" size={32} /></h1>
          <p className="parent-subtitle">تابع رحلة بطل البرمجة الصغير وشاركه نجاحاته!</p>
        </div>
      </header>

      <div className="parent-summary-cards">
        <StatCard
          title="مستوى التقدم"
          value={completedCount + " دروس"}
          icon="progress"
          variant="ocean"
          description="دروس مكتملة بنجاح"
        />
        <StatCard
          title="متوسط الدرجات"
          value={avgScore + "%"}
          icon="target"
          variant="sky"
          description="أداء متميز في التحديات"
        />
        <StatCard
          title="نقاط المكافأة"
          value={child.points}
          icon="streak"
          variant="sunshine"
          description="إجمالي نقاط الخبرة"
        />
      </div>

      <section className="child-profile-section">
        <Card className="child-main-card">
          <div className="child-header">
            <div className="child-avatar">
              <Icon name="user" size={32} />
            </div>
            <div className="child-info">
              <span className="profile-label">إحصائيات الطالب:</span>
              <h3>{studentIdentity}</h3>
              <p className="meta">مشترك منذ 3 أشهر</p>
            </div>
            <LibBadge variant="ocean">طالب نشط</LibBadge>
          </div>

          <div className="child-progress-summary">
            <div className="summary-label">
              <span>التقدم العام في المسار</span>
              <span>{Math.round((completedCount / 10) * 100)}%</span>
            </div>
            <ProgressBar value={Math.round((completedCount / 10) * 100)} size="lg" />
          </div>
        </Card>
      </section>

      <section className="activity-section">
        <h2 className="section-title">آخر النشاطات</h2>
        <div className="activity-list">
          {progress.filter(p => p.completed).length > 0 ? (
            progress.filter(p => p.completed).map(p => (
              <Card key={p.lessonId} className="activity-item">
                <div className="activity-icon">
                  <Icon name="lessons" size={24} color="var(--cw-ocean-500)" />
                </div>
                <div className="activity-details">
                  <h4>إكمال درس: {p.lessonId}</h4>
                  <p className="meta">تم الإكمال بنجاح وبدرجة ممتازة</p>
                </div>
                <div className="activity-score">
                  <span className="score-val">{p.score}%</span>
                  <LibBadge variant="success">ممتاز</LibBadge>
                </div>
              </Card>
            ))
          ) : (
            <p className="empty-activity">لا توجد نشاطات مسجلة بعد.</p>
          )}
        </div>
      </section>
    </div>
  );
}


